export class EnrollEntKtSerificateInfo {
  ent_kt_serificate_give_date: number;
  individual_code_test: number = null;
  exam_lang: number = null;
  ent_kt_serificate_series: string = '';
  ent_kt_serificate_number: number = null;
  ent_kt_serificate_best_before: Date;
  mandatory_subjects: any;
  profile_subjects: any;
  balls_sum_for_admission: number = null;
  ent_kt_serificate_scan: any;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/edu-info/enroll-ent-kt-serificate-info.ts